import React from 'react';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';

import Spinner from 'components/Spinner/view/desktop';

import useNetentTournament from '../../../model/useNetentTournament';

import bottomPrizes from './img/bottom.png';
import topPrizes from './img/top.png';
import leftImage from './img/left.webp';
import rightImage from './img/right.webp';

import prizeBoxWEBP from './img/present-box.webp';
import prizeBox2WEBP from './img/present-box-2.webp';

import './NetentTournament.scss';
import NetentTournamentItem from './NetentTournamentItem';

const b = block('bonus-program-netent-tournament-desktop');

const NetentTournament = () => {
  const { items, agentData, date, actionProcessing } = useNetentTournament();
  const locale = useSelector(state => state.locale.locale.netentTournament || {}, shallowEqual);

  return (
    <>
      <Spinner isLoading={actionProcessing} />
      <div className={b()}>
        <div className={b('content')}>
          <div className={b('light')} />
          <div className={b('header')}>
            <h2 className={b('title')}>{locale.title}</h2>
            <span className={b('description')}>{locale.description}</span>
          </div>

          <div className={b('prizes')}>
            <img src={prizeBoxWEBP} className={b('prize-box')} />
            <img src={prizeBox2WEBP} className={b('prize-box-2')} />

            <div className={b('prizes-row')}>
              <img src={topPrizes} className={b('prizes-top')} />
            </div>
            <div className={b('prizes-row-bottom')}>
              <img src={bottomPrizes} className={b('prizes-bottom')} />
            </div>
          </div>

          <div className={b('body')}>
            <img src={leftImage} className={b('left-image')} />
            <img src={rightImage} className={b('right-image')} />

            <span className={b('list-title')}>{locale.top10}</span>
            {items.length ? (
              <div className={b('list')}>
                <div className={b('list-header')}>
                  <div />
                  {[locale.number, locale.username, locale.points].map(item => (
                    <div key={item} className={b('col')}>
                      <span>{item}</span>
                    </div>
                  ))}
                </div>
                {items.map(item => (
                  <NetentTournamentItem key={item.position} item={item} />
                ))}
                {agentData.position !== -1 && (
                  <div className={b('position')}>
                    <span className={b('position-text')}>
                      {locale.positionValue?.replace('<value>', agentData.position)}
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <div className={b('no-data')}>
                <span className={b('no-data-text')}>{locale.noData}</span>
              </div>
            )}

            <div className={b('timer')}>
              <span className={b('timer-title')}>{locale.timeUntil}</span>
              <div className={b('timer-date')}>
                <span>{date}</span>
              </div>
            </div>

            <div className={b('rules')}>
              <div className={b('rules-text')}>
                {locale.rulesText}
                &nbsp;
                <span>{locale.clickHere}</span>
              </div>
              <button className={b('rules-button')}>{locale.tableHeadLink}</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NetentTournament;
